import { gql } from '@apollo/client'

export const PROMPT_PROGRESS_UPDATE = gql`
  mutation PromptProgressUpdate {
    promptProgressUpdate {
      success
    }
  }
`
